export function ValidateImageAndPdf(file, callback) {
  const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
  const allowedExtensions = /\.(png|jpe?g|pdf)$/i;
 
  if (!allowedTypes.includes(file.type) || !allowedExtensions.test(file.name)) {
    return callback(false);
  }
 
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }
 
    const isPng = header === "89504e47";
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";
    const isPdf = header === "25504446";
 
    callback(isPng || isJpeg || isPdf);
  };
 
  reader.onerror = function () {
    callback(false);
  };
 
  reader.readAsArrayBuffer(file.slice(0, 4));
}
export function ValidateImageOnly(file, callback) {
  const allowedTypes = ["image/png", "image/jpeg"];
  const allowedExtensions = /\.(png|jpe?g)$/i;
 
  if (!allowedTypes.includes(file.type) || !allowedExtensions.test(file.name)) {
    return callback(false);
  }
 
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }
 
    const isPng = header === "89504e47"; // PNG
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";
 
    callback(isPng || isJpeg);
  };
 
  reader.onerror = function () {
    callback(false);
  };
 
  reader.readAsArrayBuffer(file.slice(0, 4));
}
export function ValidateImg(file, callback) {
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }
    // File signature check
    const isPng = header === "89504e47"; // PNG signature
    const isJpeg =
      header === "ffd8ffe0" || // JPEG signature
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";
 
    const isValidImage = isPng || isJpeg;
    callback(isValidImage); // Pass the result to the callback function
  };
  reader.onerror = function () {
    callback(false); // In case of an error, return false
  };
  reader.readAsArrayBuffer(file.slice(0, 4)); // Read the first 4 bytes of the file
}
 
export const handleImageChange = (e, errorInput, url, setValue, setError, trigger, clearErrors) => {
  const file = e.target.files[0];
  if (file) {
    ValidateImg(file, (isValid) => {
      if (isValid) {
        setValue(errorInput, file); // Set as File object, not string
        const imageUrl = URL.createObjectURL(file);
        setValue(url, imageUrl);
        trigger(errorInput);
        setTimeout(() => clearErrors(errorInput), 100);
      } else {
        setError(errorInput, {
          type: "manual",
          message: "Invalid file type. Only PNG, JPEG, and JPG files are allowed.",
        });
        e.target.value = "";
      }
    });
  } else {
    setValue(errorInput, "");
  }
};
export const handleImgPdfChange = (e, errorInput, url, setValue, setError, trigger, clearErrors) => {
  const file = e.target.files[0];
  if (file) {
    ValidateImageAndPdf(file, (isValid) => {
      if (isValid) {
        setValue(errorInput, file); // Set as File object, not string
        const imageUrl = URL.createObjectURL(file);
        setValue(url, imageUrl);
        trigger(errorInput);
        setTimeout(() => clearErrors(errorInput), 100);
      } else {
        setError(errorInput, {
          type: "manual",
          message: "Invalid file type. Only PNG, JPEG, and JPG files are allowed.",
        });
        e.target.value = "";
      }
    });
  } else {
    setValue(errorInput, "");
  }
};